<template>
	 <b-row class="my-1" align-v="center">
      <b-col :sm="labelWidth"  class="text-left">
      <label class="mb-0 align-middle">{{this.label}}</label>
      </b-col>
      <b-col :sm="inputWidth">
	  <b-form-checkbox-group v-model="value"  :options="this.options" :stacked="this.stacked" :disabled='this.disabled' @change="change($event)"></b-form-checkbox-group>
     </b-col>
    </b-row>
</template>

<script type="text/javascript">
/* eslint-disable */
import Vue from 'vue'

export default{
	name:'FITCheckboxGroup',
	props:{
		label:String,
		options:{  
			type:Array,
			required:true
		},	
		width:Number,
		stacked:Boolean, // Orientation: true for Vertical, false for horizontal 
		value:Array,
		disabled:Boolean
	},
  data(){
  	return{
	    inputWidth:this.width
	   }
  },

  mounted(){
    this.labelCheck(this.label);
  },

  computed:{
  	labelWidth(){
  		return 12-this.inputWidth;
  	}
  },
   methods:{
    labelCheck(label){
      if(!label){
        this.inputWidth=12;
      }
    },
    change(event){
      this.$emit('input',event);
    }
  }
}	
</script>
<style type="text/css">
	
</style>


// WEBPACK FOOTER //
// src/components/Form/FITCheckboxGroup.vue